module.exports = __webpack_public_path__ + "static/media/pickup.9fa75006.svg";